import ProjectStory from "../../components/StreamStories/project-story";
import PhotosStory from "../../components/StreamStories/photos-story";
import ArticleStory from "../../components/StreamStories/article-story";
import NewsroomStory from "../../components/StreamStories/newsroom-story";
import FolderStory from "../../components/StreamStories/folder-story";
import BookmarksStory from "../../components/StreamStories/bookmarks-story";
import ProductStory from "../../components/StreamStories/product-story";
import SuggestionsStory from "../../components/StreamStories/suggestions-story";
import { MostVisitedArticlesWidget, MostVisitedProductsWidget } from "../MostVisitedArticles";
import FolderRecommendationsWidget from "../FolderRecommendations";
import Follow from "../../components/Follow";

export const STREAM_COMPONENTS = {
  new_project: ProjectStory,
  new_photo: PhotosStory,
  new_article: ArticleStory,
  article_published: NewsroomStory,
  new_folder: FolderStory,
  new_bookmark: BookmarksStory,
  new_product: ProductStory,
  suggestions: SuggestionsStory,
  MostVisitedArticlesWidget: MostVisitedArticlesWidget,
  MostVisitedProductsWidget: MostVisitedProductsWidget,
  FolderRecommendationsWidget: FolderRecommendationsWidget,
  follow: Follow
};

export const BASIC_STORIES = [
  // { trigger: "suggestions", type: "author", meta: "automatic" },
  // { trigger: "suggestions", type: "photographer", meta: "automatic" },
  { trigger: "suggestions", type: "office", meta: "automatic" },
  // { trigger: "suggestions", type: "company", meta: "automatic" },
  { trigger: "suggestions", type: "category", meta: "automatic" },
  { trigger: "suggestions", type: "product_category", meta: "automatic" }
  // { trigger: "MostVisitedArticlesWidget", meta: "automatic" },
  // { trigger: "MostVisitedProductsWidget", meta: "automatic" }
  // { trigger: "FolderRecommendationsWidget", meta: "automatic" }
];
